// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9NmZE","col":"styles_col__1sv6J"};